import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { MailchimpFundSyncInfo } from 'donor-elf-web/routes/funds/fund/more/mailchimp-sync';
import FundsService from 'donor-elf-web/services/funds-service';
import Settings from 'donor-elf-web/services/settings';

interface ComponentArgs {
  mailchimpFundSyncInfo: MailchimpFundSyncInfo;
  onDeleted: (mailchimpFundSyncInfo: MailchimpFundSyncInfo) => void;
  onCancel: () => void;
}

export default class MailchimpSyncFundSyncIndexComponent extends Component<ComponentArgs> {
  @service declare fundsService: FundsService;
  @service declare settings: Settings;

  @tracked deleting = false;
  @tracked error: any;

  @action
  async delete() {
    this.deleting = true;
    let mailchimpFundSync = this.args.mailchimpFundSyncInfo.mailchimpFundSync;
    try {
      await mailchimpFundSync.destroyRecord();
      // have to update settings.mailchimpFundSyncSlim
      this.settings.unload();
      await this.settings.loadSettings(this.fundsService.selectedFund!.id);
      this.args.onDeleted(this.args.mailchimpFundSyncInfo);
    } catch (e) {
      this.error = e;
    }
  }
}
